<template>
  <div class="w-40 h-40 flex rounded-4 cursor-pointer relative z-20 hover:bg-grey-400 group" @setIcon="setIcon(icon)">
    <span
      class="whitespace-no-wrap absolute z-10 shadow text-main-color px-5 rounded-4 text-10 bottom-30 font-medium opacity-0 group-hover:opacity-100"
      :class="[
        isDarkMode ? 'bg-white text-backdrop' : 'bg-backdrop text-white',
        hasRightTooltipPosition
      ]"
    >
      {{ icon }}
    </span>
    <img
      ref="iconRef"
      class="w-25 h-25 m-auto"
      :class="{'rounded-5 bg-grey-500': isOutlinedIcon && isDarkMode}"
      src="@/assets/images/icons/white-large-square.png"
      :alt="icon"
    >
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, onUnmounted, computed } from 'vue'

export default defineComponent({
  props: {
    icon: String,
    index: Number,
    chunkSize: Number,
    isDarkMode: Boolean,
    hasRightTooltipPosition: String
  },

  emits: ['setIcon', 'updateChunkSize'],

  setup (props, { emit }) {
    const iconRef = ref(null)

    const isOutlinedIcon = computed(() => props.icon.match('outlined'))

    const observer = new IntersectionObserver(([entry], observer) => {
      if (entry && entry.isIntersecting) {
        entry.target.src = require(`@/assets/images/icons/${props.icon}.png`)
        if (props.index > 28) {
          emit('updateChunkSize', props.chunkSize + 1)
        }
        observer.unobserve(entry.target)
      }
    }, { root: document.getElementById('icons') })

    onMounted(() => {
      observer.observe(iconRef.value)
    })

    onUnmounted(() => {
      observer.disconnect()
    })

    return {
      iconRef,
      isOutlinedIcon
    }
  }
})
</script>
